import { render, staticRenderFns } from "./ChannelPosts.vue?vue&type=template&id=1fbb7d44&"
import script from "./ChannelPosts.vue?vue&type=script&lang=ts&"
export * from "./ChannelPosts.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelPosts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports